import template from './template';
import Mustache from 'mustache';

export default (
  optionFull,
  optionInstallment,
  installmentMonths,
  installmentTip,
  initialPayment,
  installmentFirstPay,
) => {
  return Mustache.render(template, {
    option_full: optionFull,
    option_installment: optionInstallment,
    installment_tip: `${installmentMonths} ${installmentTip}`,
    initial_payment: `${initialPayment} - ${installmentFirstPay}%`,
  });
};